import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect } from "react";
import Import from "../Component/Dashboard/Import/Import";
import ModelConfiguration from "../Component/Dashboard/Default/TabLots/ModelConfiguration";
import DynamicModelRouter from "./DynamicModelRouter";
import ModelsVideoCodage from "../Component/Dashboard/Default/VideoCodage/ModelsVideoCodage";
import UploadDoc from "../Component/Dashboard/Default/UploadDoc/UploadDoc";
import DocumentKYC from "../Component/Dashboard/Default/DocumentKYC/DocumentKYC";
import SecureIDModal from "../Component/Dashboard/Default/DocumentKYC/ActivID/SecureIDModal";

export default function RouterUser() {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");
  const location = useLocation();

  const checkTokenExpiration = () => {
    const token = Cookies.get("Token");

    if (token) {
      const tokenExpirationTime = new Date(
        JSON.parse(atob(token.split(".")[1])).exp * 1000
      );
      const currentTime = new Date();

      if (currentTime > tokenExpirationTime) {
        Cookies.remove("Token");
        localStorage.clear();
        window.location.href = "/"; // Rediriger vers la page de déconnexion
      }
    }
  };

  useEffect(() => {
    // Vérifier périodiquement si le token a expiré (par exemple, toutes les minutes)
    const interval = setInterval(checkTokenExpiration, 60000); // Vérifier toutes les 60 secondes (60000 ms)

    return () => {
      clearInterval(interval); // Nettoyer l'intervalle à la suppression du composant
    };
  }, []);

  // Autoriser accès KYC via QR (param 'kyc' ou donnée locale) même sans session
  const isKycAccess =
    location.pathname.includes("/DocumentKYC") &&
    (new URLSearchParams(location.search).has("kyc") ||
      !!localStorage.getItem("kyc_waiting"));

  if ((!token || role !== "user") && !isKycAccess) {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      Cookies.remove(cookieName);
    });
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Routes>
        <Route index element={<ModelConfiguration />} />

        <Route path=":configKey" element={<DynamicModelRouter />} />

        <Route path="Import" element={<Import />} />
        <Route path="ModelsVideoCodage" element={<ModelsVideoCodage />} />
        <Route path="UploadDoc" element={<UploadDoc />} />
        <Route path="/DocumentKYC" element={<DocumentKYC />} />
        <Route path="/DocumentKYC/SecureID" element={<SecureIDModal />} />
        <Route path="*" element={<Navigate to="/User" replace />} />
      </Routes>
    </>
  );
}
